module.exports = __webpack_public_path__ + "static/media/Montagu.095b0977.webp";